<template>
  <ClientOnly>
    <Teleport to="#teleports">
      <template v-if="isDesktopScreen || isTabletScreen">
        <TsModal
            v-bind="$attrs"
            append-class="bg-transparent overflow-hidden"
            @hide="resetBranchModalStates"
        >
          <template #modal-content>
            <TsCardBranchV1
                @save="emit('save')"
                data-testid="branch-selector-modal"
                @close="()=>{branchStore.branchSelectorModalVisible = false;
            branchStore.isDefaultBranchSelected = false}"
            />
          </template>
        </TsModal>
      </template>

      <template v-else-if="isMobileScreen">
        <TsDrawer
            v-bind="$attrs"
            append-class="bg-transparent overflow-hidden"
            position="bottom"
            @drawer-close="resetBranchModalStates"
        >
          <TsCardBranchV1
              @save="emit('save')"
              data-testid="branch-selector-modal"
              @close="()=>{branchStore.branchSelectorModalVisible = false;
            branchStore.isDefaultBranchSelected = false}"
          />
        </TsDrawer>
      </template>
    </Teleport>
  </ClientOnly>
</template>

<script lang="ts" setup>
import { useScreenSize } from "~/composables/useScreenSize";
// Store component instances for proper cleanup
const componentInstances = ref({
  cardBranch: null,
  drawer: null
});

const TsCardBranchV1 = defineAsyncComponent({
  loader: () => import('~/components/organisms/TsCardBranchV1.vue'),
  onError(error, retry, fail, attempts) {
    console.error('Error loading TsCardBranchV1:', error);
    if (attempts <= 3) {
      retry();
    } else {
      fail();
    }
  }
});

const TsDrawer = defineAsyncComponent({
  loader: () => import('~/components/organisms/TsDrawer.vue'),
  onError(error, retry, fail, attempts) {
    console.error('Error loading TsDrawer:', error);
    if (attempts <= 3) {
      retry();
    } else {
      fail();
    }
  }
});

defineOptions({
  inheritAttrs: false,
});

const emit = defineEmits<{
  save: any;
}>();

const { isMobileScreen, isDesktopScreen, isTabletScreen } = useScreenSize();
const branchStore = useBranchStore();

function resetBranchModalStates(){
  branchStore.localitySearchInput = '';
  branchStore.autoCompleteSuggestions = [];
  branchStore.resetStatuses();
}

// Clean up resources when component is unmounted
onBeforeUnmount(() => {
  // Clean up component instances
  componentInstances.value = {
    cardBranch: null,
    drawer: null
  };

  // Reset branch store states
  resetBranchModalStates();
});
</script>
